import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { enTypeToastNotificationMessage, INotification } from 'interface/toastNotification';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { removeMessage } from 'actionCreators/toastNotifications';
import CloseIcon from '@material-ui/icons/Close';

interface IProps {
  message: INotification;
  index: number;
  removeMessage: typeof removeMessage;
}

const useStyles = makeStyles({
  root: {
    position: 'fixed',
    right: 20,
    zIndex: 1400,
    color: '#FFF',
    height: 50,
    maxHeight: 50,
    width: 300,
    maxWidth: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 12,
    borderRadius: 4,
    '&:first-child': { top: 10 },
  },
  closeIcon: {
    cursor: 'pointer'
  },
  message: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
})

const ComponentItem = ({ message, index, removeMessage }: IProps) => {
  const classes = useStyles();

  useEffect(() => {

    const timeOut = setTimeout(() => {
      removeMessage(message.id);
    }, 4000);

    return () => {
      clearTimeout(timeOut);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkBgColor = () => {
    if (message.type === enTypeToastNotificationMessage.ERROR) {
      return 'red'
    }
    if (message.type === enTypeToastNotificationMessage.SUCCESS) {
      return 'green'
    }

    return ''
  }

  const removeMsg = () => {
    removeMessage(message.id);
  }

  return (
    <Paper elevation={4}>
      <div
        className={classes.root}
        style={{ top: (index * 50 + (index === 0 ? 10 : (index + 1) * 10)), backgroundColor: `${checkBgColor()}` }}
      >
        <div className={classes.message}>{message.msg}</div>
        <div onClick={removeMsg} className={classes.closeIcon}><CloseIcon /></div>
      </div>
    </Paper>
  );
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps
  }
}

export default connect(mapStateToProps, { removeMessage })(ComponentItem);